import { render, staticRenderFns } from "./requestStatusComponent.vue?vue&type=template&id=9d9db36a&"
import script from "./requestStatusComponent.vue?vue&type=script&lang=js&"
export * from "./requestStatusComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports